import importFile from '@/components/shared/popup/import.vue'
import property from '@/components/shared/popup/property.vue'

export default {
    import: importFile,
    property
}
